import React from "react";

import "./Input.css";

export default function Input({ title, value, options, handleChange }) {
  return (
    <div className="input">
      <div className="input-title">{title}</div>

      <div className="input-value">
        <select
          value={value}
          onChange={(event) => handleChange(event.target.value)}
        >
          {options.map((item) => (
            <option key={item.value} value="someOption">
              {item.value}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
